import createTaxonomyLink from './createTaxonomyLink';
import filter from 'lodash/filter';
import createTaxonomyListFromQuery from './createTaxonomyListFromQuery';

export default (query, filterType, taxonomy) => {
	const queryTaxonomyList = createTaxonomyListFromQuery(query);
	const removeTaxonomyList = filter(queryTaxonomyList, item => !(item._type === filterType && item.slug === taxonomy));

	return createTaxonomyLink(removeTaxonomyList);
};